import React from 'react';
import { GiftCardCategoryType } from 'utils/types';

type PreviewProps = {
  data: GiftCardCategoryType | undefined;
};

const PreviewCategoryDetails = ({ data }: PreviewProps) => {
  return (
    <div>
      <div className='border border-[#EAEBEB] rounded-xl py-[18px] px-6 flex items-center'>
        <p className='text-[#858585] text-sm mr-7'>Category Name</p>
        <p className='text-[16px] text-[#1A1A1A] font-medium'>
          {data?.emoji ?? ''}
          {data?.name ?? '-'}
        </p>
      </div>
      <div className='border border-[#EAEBEB] rounded-xl mt-6 '>
        <p className='px-6 py-[18px] font-medium text-[#858585] text-sm '>
          Category Recommended Images
        </p>
        <hr className='text-[#EAEBEB]' />
        <div className='p-6 grid grid-cols-1 sm:grid-cols-3 gap-4'>
          {data?.images.map((item) => (
            <img
              key={item?.id}
              src={item?.image_url}
              alt='category-images'
              className='rounded-[10px] w-[222px] h-[160px] object-cover'
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewCategoryDetails;
